
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import { GenMetricSource } from './GenMetricSource';
import { GenRestorationCurve } from './GenRestorationCurve';
import { GenWeatherPhenom } from './GenWeatherPhenom';
import moment from 'moment';

export class GenRestorationMetrics {

    id: number;
    auc: number;
    countyName: string;
    eventDuration: number;
    fipsCode: string;
    groupId: number;
    impactDuration: number;
    impactLevel: number;
    impactRate: number;
    outageId: string;
    peakTime: moment.Moment;
    recoveryDuration: number;
    recoveryImpactRatio: number;
    recoveryRate: number;
    res0: number;
    res100: number;
    res20: number;
    res40: number;
    res60: number;
    res80: number;
    restorationCurves: GenRestorationCurve[];
    source: GenMetricSource;
    stateAbbreviation: string;
    weatherPhenoms: GenWeatherPhenom[];
    year: number;

    constructor();
    constructor( jsonObj: any );
    constructor( genRestorationMetrics: GenRestorationMetrics);
    constructor( id: number );

    constructor( input?: GenRestorationMetrics|number ) {
        if ( typeof input === 'number') {
            this.id = input;
        }

        if ( input && typeof input !== 'number' ) {
            this.id = input.id; // int [number]
            this.auc = input.auc; // float [number]
            this.countyName = input.countyName; // string [string]
            this.eventDuration = input.eventDuration; // float [number]
            this.fipsCode = input.fipsCode; // string [string]
            this.groupId = input.groupId; // int [number]
            this.impactDuration = input.impactDuration; // float [number]
            this.impactLevel = input.impactLevel; // float [number]
            this.impactRate = input.impactRate; // float [number]
            this.outageId = input.outageId; // string [string]
            if ( input.peakTime && typeof input.peakTime === 'string' ) {
                this.peakTime = moment(input.peakTime).utc();
            } else {
                this.peakTime = input.peakTime;
            }
            this.recoveryDuration = input.recoveryDuration; // float [number]
            this.recoveryImpactRatio = input.recoveryImpactRatio; // float [number]
            this.recoveryRate = input.recoveryRate; // float [number]
            this.res0 = input.res0; // float [number]
            this.res100 = input.res100; // float [number]
            this.res20 = input.res20; // float [number]
            this.res40 = input.res40; // float [number]
            this.res60 = input.res60; // float [number]
            this.res80 = input.res80; // float [number]
            if ( input.restorationCurves && input.restorationCurves.map ) { // list [GenRestorationCurve]
                this.restorationCurves = input.restorationCurves.map( ( x: GenRestorationCurve ) => {
                    return new GenRestorationCurve( x );
                } );
            } else {
                this.restorationCurves = input.restorationCurves;
            }
            this.source = (typeof input.source === 'string') ? GenMetricSource.forName(<string> input.source) : <any> input.source; // GenMetricSource
            this.stateAbbreviation = input.stateAbbreviation; // string [string]
            if ( input.weatherPhenoms && input.weatherPhenoms.map ) { // list [GenWeatherPhenom]
                this.weatherPhenoms = input.weatherPhenoms.map( ( x: GenWeatherPhenom ) => {
                    return new GenWeatherPhenom( x );
                } );
            } else {
                this.weatherPhenoms = input.weatherPhenoms;
            }
            this.year = input.year; // int [number]
       }
    }

    static jsonResponseToList(arr: any[]): GenRestorationMetrics[] {
        if (arr && arr.map) {
          return arr.map(a => new GenRestorationMetrics(a));
        } else {
          return [];
        }
    }
}

